export default __webpack_public_path__ + "static/media/SkybagsMarvel.7c8db642.jpg";